import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import { State } from "vuex-class";
let PiHomeDataHeader = class PiHomeDataHeader extends Vue {
    constructor() {
        super(...arguments);
        this.timeStr = "";
        this.timer = 0;
        this.oprPkId = "";
    }
    getTime() {
        const time = this.$common.thisTimes("allTime");
        this.timeStr = time;
    }
    operChange(val) {
        this.$emit("operChange", val);
    }
    goHome() {
        this.$router.push("/home/index");
    }
    activated() {
        this.getTime();
        this.timer = setInterval(() => {
            this.getTime();
        }, 1000);
    }
    deactivated() {
        clearInterval(this.timer);
    }
};
__decorate([
    State("sys")
], PiHomeDataHeader.prototype, "sys", void 0);
PiHomeDataHeader = __decorate([
    Component({
        components: {
            piSelectOper,
        },
    })
], PiHomeDataHeader);
export default PiHomeDataHeader;
